import { Route, Routes } from "react-router";
import Home from "../Home";
import Login from "../LogIn";
import AcceptingUsers from "../AcceptingUsers";
import Specialists from "../Specialists";
import Users from "../Users";
import AcceptingSpecialists from "../AcceptingSpecialists";
import RequiredAuth from "../../../utils/AdminAuth";
import UsersComments from "../UsersComments";
import Settings from "../Settings";
import DashboardProvider from "./DashboardProvider";
import NotFound from "../../Website/NotFound";
import Service from "../CMS/Services";
import HomeServices from "../CMS/HomeServices";
import HomeHero from "../CMS/HomeHero";

export default function AdminLayout() {
  return (
    <>
      <Routes>
        <Route index element={<Login />} />
        <Route element={<RequiredAuth />}>
          <Route element={<DashboardProvider />}>
            <Route path='home' element={<Home />} />
            <Route path='users' element={<Users />} />
            <Route path='specialists' element={<Specialists />} />
            <Route path='accepting-users' element={<AcceptingUsers />} />
            <Route
              path='accepting-specialists'
              element={<AcceptingSpecialists />}
            />
            <Route path='users-comments' element={<UsersComments />} />
            <Route path='settings' element={<Settings />} />
            <Route path='CMS-home-hero' element={<HomeHero />} />
            <Route path='CMS-home-services' element={<HomeServices />} />
            <Route path='CMS-services' element={<Service />} />
          </Route>
        </Route>
        <Route path='*' element={<NotFound />} />
      </Routes>
    </>
  );
}
